"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilteredOptions = useFilteredOptions;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// TODO: V should generic with constraints.
function useFilteredOptions(_ref) {
  let {
    searchTerm,
    options = [],
    excludedKeys = [],
    groupTitleOptions = [],
    searchOptionsBy = (option, searchTerm) => {
      // $FlowFixMe
      const {
        label,
        key
      } = option;
      return key.toLowerCase().includes(searchTerm) || (label ? label.toLowerCase().includes(searchTerm) : false);
    }
  } = _ref;
  // Memoize the filterExcluded function for performance
  const filterExcluded = React.useCallback(list =>
  // $FlowFixMe - list has key property
  list ? list.filter(option => !excludedKeys.includes(option.key)) : [], [excludedKeys]);
  return React.useMemo(() => {
    const trimmedValue = (searchTerm || '').trim().toLowerCase();

    // Initialize filteredOptions as an empty array if options are not provided
    let filteredOptions = [];
    if (options.length) {
      filteredOptions = filterExcluded(options);

      // Apply search term filtering
      if (trimmedValue) {
        filteredOptions = filteredOptions.filter(option => searchOptionsBy(option, trimmedValue));
      }
    }
    let filteredGroupTitleOptions = [];

    // Process groupTitleOptions if provided
    if (Array.isArray(groupTitleOptions) && groupTitleOptions.length) {
      filteredGroupTitleOptions = groupTitleOptions.map(group => {
        const filtered = filterExcluded(group.options).filter(option => !trimmedValue || searchOptionsBy(option, trimmedValue));
        return {
          ...group,
          options: filtered
        };
      }).filter(group => group.options ? group.options.length > 0 : false);
    }
    return {
      filteredOptions,
      filteredGroupTitleOptions
    };
  }, [searchTerm, options, excludedKeys, groupTitleOptions, searchOptionsBy, filterExcluded]);
}